import React, { useCallback } from 'react';
import { formatTranslation } from 'intl';
import { useIntl } from 'react-intl';
import { DocumentationPlusIcon } from 'components/core/Navigation/NavigationDrawer/icons';
import { useGalleryContext } from '..';
import { identitySelector } from '../selectors';
import { ActionButton } from './actionButton';
import { useExportToDocumentationOptional } from 'components/documentation/ExportToDocumentationDialog';
import { isFileExportAllowed } from 'services/fileService';
import { CommonTranslationKeys } from 'intl/keys';

interface ExportToDocumentationButtonProps {
  isMobile: boolean;
}

export const ExportToDocumentationButton: React.FC<
  ExportToDocumentationButtonProps
> = ({ isMobile }) => {
  const intl = useIntl();
  const [file] = useGalleryContext().useMainDisplayedFile(identitySelector);
  const exportContext = useExportToDocumentationOptional();

  if (!exportContext) {
    return null;
  }

  const { openExportDialog } = exportContext;
  const exportAllowed = isFileExportAllowed(file);

  if (file?.documentationId) return null;

  const label = formatTranslation(intl, CommonTranslationKeys.exportToDocumentation,);
  const notAllowedLabel = formatTranslation(intl, CommonTranslationKeys.exportToDocumentationNotAllowed,);
  const disabled = !file || !exportAllowed;
  const tooltipTitle = disabled && file && !exportAllowed ? notAllowedLabel : label;

  const handleExport = useCallback((): void => {
    if (!file || !exportAllowed) return;
    openExportDialog(file);
  }, [file, exportAllowed, openExportDialog]);

  return (
    <ActionButton
      isMobile={isMobile}
      onClick={handleExport}
      disabled={disabled}
      tooltipTitle={tooltipTitle}
      label={label}
      icon={<DocumentationPlusIcon fontSize="small" />}
    />
  );
};
